var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.04,
    height: 17.22,
    viewBox: "0 0 18.04 17.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.609 0a8.61 8.61 0 1 0 7.7 12.435l.525 1.685a.617.617 0 0 0 1.179-.365l-1.025-3.28a.615.615 0 0 0-.673-.429.625.625 0 0 0-.109.032l-3.69 1.23a.615.615 0 1 0 .384 1.166l2.4-.8a7.282 7.282 0 0 1-6.694 4.318 7.38 7.38 0 0 1 0-14.76 7.471 7.471 0 0 1 6.63 3.972.615.615 0 1 0 1.092-.566A8.687 8.687 0 0 0 8.609 0z",
    "data-name": "Path 414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.3e42d5fa5e770d01b18f6df98cf858ae.svg";
export { ForwardRef as ReactComponent };